import { render, staticRenderFns } from "./ddhj.vue?vue&type=template&id=5f3df6fd&scoped=true&"
import script from "./ddhj.vue?vue&type=script&lang=js&"
export * from "./ddhj.vue?vue&type=script&lang=js&"
import style0 from "./ddhj.vue?vue&type=style&index=0&id=5f3df6fd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3df6fd",
  null
  
)

export default component.exports